import { PowerOffOutlined, PowerOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material'

import { UnknownBubble } from '../data-icons'

const PowersourceBubble = ({ value, isOffline }: { value: string; isOffline: boolean }) => {
  const theme = useTheme()

  const offlineText = isOffline ? ' (Offline)' : ''

  const { ariaLabel, iconColor, IconComponent } = {
    BATT: { ariaLabel: 'Battery powered', iconColor: theme.palette.error.main, IconComponent: PowerOffOutlined },
    LINE: { ariaLabel: 'Line powered', iconColor: theme.palette.success.light, IconComponent: PowerOutlined },
  }[value] ?? { ariaLabel: 'Unknown', iconColor: theme.palette.text.primary, IconComponent: UnknownBubble }

  return <IconComponent htmlColor={isOffline ? theme.palette.divider : iconColor} aria-label={`${ariaLabel}${offlineText}`} />
}

export default PowersourceBubble
